import { reactive } from 'vue';

const storeDefault = {
  list: [],
};

const store = reactive(storeDefault);

const getters = {
    list: store => store.list,
}

const isDuplicate = (payload,notification) => {
  return notification.text === payload.text || (notification.id && notification.id === payload.id);
};

export const notifications = {
  namespaced: true,
  state: store,
  mounted() {

  },
  methods: {
    isDuplicate(payload,notification) {
      return isDuplicate(payload,notification);
    },
    isDuplicateInList(payload) {
      return this.list.some(notification => isDuplicate(payload,notification));
    }
  },
  mutations: {
    ADD_NOTIFICATION(state, payload) {
        state.list = state.list.filter((notification) => !isDuplicate(payload,notification));
        state.list.push(payload);
    },

    REMOVE_NOTIFICATION(state, payload) {
        state.list = state.list.filter(notification => !isDuplicate(payload,notification));
    }
  },
  getters: getters

};
